module.exports = __webpack_public_path__ + "static/media/color_blind_image_3.4a775ed7.jpg";